<div class="grid gap-{{gap}}">
    <ng-content></ng-content>
</div>